import React, {useEffect, useState} from 'react';
import {checkNullStr, getDefStr} from "../utils/ReactUtils";
import {Label, NullMsgLabel} from "../index";

const PdfViewer = React.memo(({
                                  wrapperClassName = "",
                                  nullMessageClassName = '',
                                  className = "",
                                  labelClassName = "",
                                  label,
                                  pdfTitle,
                                  nullMessage = 'Document preview not available',
                                  nullMessageAt = 'center',
                                  src,
                                  labelColor,
                                  onError,
                                  nullMessageColor = '',
                                  labelAt = 'start',
                                  height = '50vh',
                                  style = {},
                                  wrapperStyle = {},
                                  labelStyle = {},
                              }) => {
    const TAG = "PdfViewer";
    const [errorFound, setErrorFound] = useState({has: false, error: ""});

    useEffect(() => {

    }, []);
    return (<>
            <div className={`${wrapperClassName}`} style={{height: checkNullStr(src) ? height : 'auto'}}>
                {checkNullStr(label) &&
                    <div>
                        <Label className={`text-input-label px-2 ${labelClassName}`}
                               style={labelStyle} textAt={labelAt} color={labelColor}>
                            {label}
                        </Label>
                    </div>}

                {(checkNullStr(src) || !errorFound.has) ? <div className={'bg-dangerx w-100'}>
                        <iframe
                            className={`w-100 rounded-3 overflow-hidden p-0 m-0 ${className}`}
                            width="100%"
                            style={style}
                            title={pdfTitle}
                            src={src}
                            // height={'100%'}
                            height={getDefStr(height, '100%')}
                            onChange={() => {
                                setErrorFound({has: false});
                            }}
                            onError={(e) => {
                                setErrorFound({has: true, error: e});
                                console.error(TAG, 'iFrame.onError.e:', e);
                                if (onError) onError(e);
                            }}
                        >
                        </iframe>
                    </div>
                    : <NullMsgLabel
                        className={`fs-xl mt-n2 ${nullMessageClassName}`}
                        color={nullMessageColor}
                        textAt={nullMessageAt}>{errorFound.has ? "Unable to read file!" : nullMessage}
                    </NullMsgLabel>}
            </div>
        </>
    )

});
export default PdfViewer;
